var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWrapup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "wrapup",
    width: "64px",
    height: "64px",
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon/wrapup") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "wrapup-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "wrapup-2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "wrapup-3",
    stroke: "#151515",
    strokeWidth: 6,
    x: 11,
    y: 11,
    width: 42,
    height: 42
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "wrapup-4",
    fill: "#000000",
    fillRule: "nonzero",
    points: "47.5675676 25.7114286 28.0562162 44.5 16.4324324 33.2542857 21.7681399 28.0428571 28.0562162 34.0771429 42.2318601 20.5"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWrapup);
export default __webpack_public_path__ + "static/media/wrapup.d03684064b5a1f29db544668736e7bc2.svg";
export { ForwardRef as ReactComponent };